import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { AmountCard } from "./RefundTabs.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { NotifyError } from "../../utils/ShowError";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import CONSTANTS from "../../utils/constants";
import User from "../../stores/UserStore";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import userStore from "../../stores/UserStore";
import isValidIban from "../../utils/validateIban";
import zIndex from "@mui/material/styles/zIndex";
interface Obj {
  [key: string]: any;
}

type BankDetails = {
  customerName: string;
  bankAccountNumber: string;
  ibanNumber: string;
  swiftCode: string;
  bankBranchName: string;
  bankType: string;
  bankName: string;
  country: string;
};
interface BankOption {
  bankName: string;
  id: number;
  swiftCode: string;
  otherBankName: string;
}

interface Props extends BaseProps {
  selectedAccounts: Obj[];
  bankData: Obj;
  makeRefund: (bankDetails: any,edit:any) => void;
  refundLoader:Boolean;
}

const RefundDetails: FC<Props> = ({
  makeRefund,
  Previous,
  bankData,
  selectedAccounts,
  refundLoader
}: Props): ReactElement => {
  const [edit, setEdit] = useState(false);

  const customerNameRef = useRef<HTMLInputElement | null>(null);
  const bankTypeRef = useRef<HTMLSelectElement | null>(null);
  const bankAccountNumberRef = useRef<HTMLInputElement | null>(null);
  const bankAccountReferenceIdRef = useRef<HTMLInputElement | null>(null);
  const ibanNumberRef = useRef<HTMLInputElement | null>(null);
  const swiftCodeRef = useRef<HTMLInputElement | null>(null);
  const bankBranchNameRef = useRef<HTMLInputElement | null>(null);
  const bankNameRef = useRef<HTMLInputElement | null>(null);
  const otherBankNameRef = useRef<HTMLInputElement | null>(null);
  const countryRef:any=useRef<HTMLSelectElement | null>(null);
  const [bankTypeValue, setBankType] = useState(bankData.bankType?.value);
  const [loader, setLoader] = useState(false)
  const [bankNames, setBankNames] = useState<BankOption[]>([])
  
  const handleMakeRefund = async() => {
    setLoader(true)
    const customerName :any= customerNameRef.current?.value;
    const bankType :any= bankTypeRef?.current?.value;
    const bankAccountNumber = bankAccountNumberRef.current?.value;
    // const bankAccountReferenceId = bankAccountReferenceIdRef.current?.value
    const ibanNumber :any= ibanNumberRef.current?.value;
    const swiftCode :any= swiftCodeRef.current?.value;
    const bankBranchName :any= bankBranchNameRef.current?.value;
    const bankName :any= openBankNameInput? otherBankNameRef.current?.value: bankNameRef.current?.value;
    const country :any= countryRef.current?.value;
    if(!isValidIban(ibanNumber)){
      NotifyError(General?.codeLabels['cm_iban_invalid']?.label)
      setLoader(false);
      return;
    }
    if (
      !customerName ||
      !bankType ||
      !bankAccountNumber ||
      !ibanNumber ||
      !swiftCode ||
      !bankBranchName ||
      !bankName ||
      !country ||
      (openBankNameInput && otherBankNameRef.current?.value === '')
    ) {
      //error
      NotifyError("Error: Invalid Form");
      return;
    }
    const data = {
      customerName,
      bankType:bankTypeRef?.current?.value,
      bankAccountNumber,
      ibanNumber,
      swiftCode,
      bankBranchName,
      bankName,
      country,
      action:bankData && bankData.bankAccountReferenceId ? 'UPDATE' : 'ADD',
      bankAccountReferenceId:bankData?.bankAccountReferenceId?bankData?.bankAccountReferenceId:null
    };
    const bankDetails = {
      customerName,
      bankType:bankTypeRef?.current?.value,
      bankAccountNumber,
      ibanNumber,
      swiftCode,
      bankBranchName,
      bankName,
      country,
      action:bankData && bankData.bankAccountReferenceId ? 'UPDATE' : 'ADD',
     
    };
  
    try{
      if(edit){
        const res= await userStore.updateBankDetails({ errorId: 'updateBankDetailsError', data })
        if(res?.result?.cmRefundBankAccountService?.output?.status == "S"){
         makeRefund(bankDetails,edit);
         setLoader(false);
        }
      }else{
        makeRefund(bankDetails,edit);
      }
    }catch(error){
      setLoader(false);
    }

  };
  const ibanRegexUAE: any = /AE[0-9]{2}[0-9]{3}[0-9]{16}$/;
  const ibanRegexIn: any =
    /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/;
  const swiftCodeRegex: any =
  /^[A-Za-z0-9]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;

  const validationSchema = Yup.object().shape({
    name: Yup.string() .matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_valid_accoName"]?.label ?General?.codeLabels["cm_valid_accoName"]?.label:"Please Enter Valid Account Name").required(General?.codeLabels["cm_enter_customername"]?.label?General?.codeLabels["cm_enter_customername"]?.label:"Account number missing"),
    // bankType: Yup.string().required(General?.codeLabels["cm_ank_type_req"]?.label ?General?.codeLabels["cm_ank_type_req"]?.label:"Bank Type is required"),
    accNumber: Yup.string()
      .matches(/^\d{16}$/, General?.codeLabels["cm_bank_16"]?.label ?General?.codeLabels["cm_bank_16"]?.label:"Bank Account Number must be 16 digits")
      .required(General?.codeLabels["cm_enter_bankacctno"]?.label ?General?.codeLabels["cm_enter_bankacctno"]?.label:"Please Enter Bank Account Number"),
      iban: Yup.string()
      .matches(bankTypeValue=="DOMESTIC"? ibanRegexUAE:ibanRegexIn, General?.codeLabels["cm_ibanvalidationspclchar"]?.label ?General?.codeLabels["cm_ibanvalidationspclchar"]?.label:"Invalid IBAN format")
      .required(General?.codeLabels["cm_enter_iban"]?.label ?General?.codeLabels["cm_enter_iban"]?.label:"Required"),
      swift: Yup.string()
      .matches(swiftCodeRegex, General?.codeLabels["cm_invalid_swift"]?.label ?General?.codeLabels["cm_invalid_swift"]?.label:"Invalid Swift Code format")
      .required(General?.codeLabels["cm_enter_swiftcode"]?.label ?General?.codeLabels["cm_enter_swiftcode"]?.label:"Required"),
      branchName: Yup.string().matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_branchnamelimit"]?.label ?General?.codeLabels["cm_branchnamelimit"]?.label:"Please Enter Valid Branch Name")
      .min(4, General?.codeLabels["cm_invali_ptn"]?.label ?General?.codeLabels["cm_invali_ptn"]?.label:"Bank Branch Name must be at least 4 characters")
      .required(General?.codeLabels["cm_enter_bankbranchname"]?.label ),
    bankName: Yup.string()
      // .matches(/^[a-zA-Z\u0600-\u06FF\u0900-\u097F ,&/]+$/, General?.codeLabels["cm_valid_bnkName"]?.label ? General?.codeLabels["cm_valid_bnkName"]?.label : "Please Enter Valid Bank Name")
      .required(General?.codeLabels["cm_enter_bank_name"]?.label ? General?.codeLabels["cm_enter_bank_name"]?.label : "Bank Branch Name Required"),
    // Add validations for other fields
    // country: Yup.string().required(General?.codeLabels["cm_country_req"]?.label ?General?.codeLabels["cm_country_req"]?.label:"Country is required"), // Add validation for "country" field
  });
  useEffect(() => {
      const fetchBankOptions = async () => {
        const options = await User.getSwiftCode({
          errorId: "getBankDataError",
          data: User.profile.language.key,
        });
        console.log("bankNames for swift code", options.result);
        setBankNames(options.result);
        // setBankOptions(prev => [...prev, options.bankName]);
      };
      fetchBankOptions();
  }, []);
  const [openBankNameInput, setOpenBankNameInput] = useState(false);
  return (
    <>
      <TabContainer style={{flexDirection:'column',
        display:General?.isLargeScreen?"":'flex'}}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "space-between",
            paddingTop: "30px",
          }}
        >
          <span
            style={{
              fontSize: `${General.accessibility.fontSize}rem`,
              fontWeight: "400",
              fontStyle: "normal",
              lineHeight: "20px",
              paddingBottom: "20px",
            }}
            className={General?.textClass}
          >
           {General?.codeLabels["cm_transfer_confirm"]?.label !== undefined ? General?.codeLabels["cm_transfer_confirm"]?.label : " Confirm the bank account to transfer selected amount"}
          </span>
          <AmountCard style={{width:General?.isLargeScreen?"":"100%"}}>
            <span
              style={{
                fontSize: `${1.25 * General.accessibility.fontSize}rem`,
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "32px",
              }}
              className={General?.textClass}
            >
              {General?.codeLabels["cm_pdc_amountinaed"]?.label !== undefined ? General?.codeLabels["cm_pdc_amountinaed"]?.label : "Amount (AED)"}
            </span>
            <span
              style={{
                fontSize: `${2.5 * General.accessibility.fontSize}rem`,
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "32px",
                direction:'ltr'
              }}
              className={General?.textClass}
            >
              {new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(selectedAccounts.reduce((partialSum: any, a) => {
                if (a.accountBalance) return partialSum + a.accountBalance;
              }, 0))}
            </span>
          </AmountCard>
        </div>
        <div
          style={{
            gridColumn: General?.isLargeScreen?"1 / span 2":"",
            display: "flex",
            flexDirection:General?.isLargeScreen?"row":"column",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3
            style={{
              fontWeight: "700",
              fontStyle: "normal",
              fontSize: `${1.5 * General.accessibility.fontSize}rem`,
              lineHeight: "32px",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_confirmbankdetails"]?.label !== undefined
              ? General?.codeLabels["cm_confirmbankdetails"]?.label
              : "Confirm your Bank Account Details"}
          </h3>
          <ButtonSecondary
            style={{
              width:General?.isLargeScreen? "10%":"100%",
              padding: "5px 45px",
              marginBottom:General?.isLargeScreen?"":"10px",
              fontSize: `${General.accessibility.fontSize}rem`,
            }}
            onClick={() => setEdit((prev) => !prev)}
            className={General?.colorClass}
          >
            {bankData && bankData.bankAccountReferenceId ? edit ? General?.codeLabels["cm_cancel"]?.label : General?.codeLabels["cm_edit"]?.label: edit ? General?.codeLabels["cm_cancel"]?.label : General?.codeLabels["cm_mob_add"]?.label}
          </ButtonSecondary>
        </div>
      </TabContainer>

        <Formik
      initialValues={{ 
        name:bankData.customerName ? bankData.customerName : "", 
        country:bankData.country?.key ? bankData.country.key : "",
        accNumber:bankData?.bankAccountNumber ? bankData.bankAccountNumber : "",
        iban:bankData.ibanNumber ? bankData.ibanNumber : "",
        swift:bankData.swiftCode ? bankData.swiftCode : "",
        bankName:bankData.bankName ? bankData.bankName : "",
        branchName:bankData.bankBranchName ? bankData.bankBranchName : "",
        bankType:bankData.bankType?.key == "I" ? "INTERNATIONAL" : "DOMESTIC",

      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          // alert(JSON.stringify(values, null, 2));
          handleMakeRefund();
          setSubmitting(false);
        }, 400);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        validateForm
        /* and other goodies */
      }) => (
        <form onSubmit={handleSubmit}>

      <TabContainer style={{ display:General?.isLargeScreen? "grid":"flex",
          flexDirection:General?.isLargeScreen?"row":"column",}}>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
            {General?.codeLabels["cm_customername"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_customername"]?.label
                      : "Customer Name"}*
          <Field
            disabled={edit ? false : true}
            type="text"
            name="name"
            placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
            // defaultValue={bankData.customerName ? bankData.customerName : ""}
            style={{ background: !edit ? "#fff" : "#edf4f6" }}
            innerRef={customerNameRef}
          />
            <div style={{height:'0.5rem'}}>
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="error-message"
                  />
                  </div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_banktype"]?.label !== undefined
            ? General?.codeLabels["cm_banktype"]?.label
            : "Bank Type"}*
         <Field
          as="select"
          disabled={edit ? false : true}
          value={bankTypeValue}
          innerRef={bankTypeRef}
          onChange={(e: any) => setBankType(e.target.value)}
          name="bankType"
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            background: !edit ? "#fff" : "#edf4f6" 
          }}
        >
          <option
            selected={bankData.bankType?.key == "I" ? false : true}
            value={"DOMESTIC"}
          >
            {General?.codeLabels["cm_domestic"]?.label !== undefined
              ? General?.codeLabels["cm_domestic"]?.label
              : "Domestic"}
          </option>
          {/* <option
            selected={bankData.bankType?.key == "I" ? true : false}
            value={"INTERNATIONAL"}
          >
            {General?.codeLabels["cm_international"]?.label !==
            undefined
              ? General?.codeLabels["cm_international"]?.label
              : "International"}
          </option> */}
        </Field>
        <div style={{height:'0.5rem'}}></div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_country"]?.label !== undefined
            ? General?.codeLabels["cm_country"]?.label
            : "Country"}*
       
            <select
                      disabled={edit ? false : true}
                      name="country"
                      ref={countryRef}
                      style={{
                        background: !edit ? "#fff" : "#edf4f6" 
                      }}
                      // onChange={handleNationalityChange}
                    >
                  {bankTypeRef?.current?.value=='INTERNATIONAL'?
                    <>
                        <option value={""}>
                        {General?.codeLabels["cm_mob_select"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mob_select"]?.label
                          : "Select"}
                      </option>
                      {General?.codeLabels["cm_pdc_paymentaccounts"]
                        ?.languageCode == "ARA"
                        ? CONSTANTS.countriesAr.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })
                        : General?.codeLabels["cm_pdc_paymentaccounts"]
                            ?.languageCode == "HIN"
                        ? CONSTANTS.countriesHi.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })
                        : CONSTANTS.countriesEn.map((nationality) => {
                            return (
                              <option
                                value={nationality?.key}
                                selected={
                                  bankData?.country?.key == nationality?.key
                                    ? true
                                    : false
                                }
                              >
                                {nationality?.value}
                              </option>
                            );
                          })}
                    </>
                    :
                    <>
                    {General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "ARA"
                          ?
                                <option
                                  value={"ARE"}
                                >
                                  {"الإماراتالعربيةالمتحدة"}
                                </option>
  
                          : General?.codeLabels["cm_pdc_paymentaccounts"]
                              ?.languageCode == "HIN"
                          ?
                                <option
                                  value={"ARE"}
                                >
                                  {"संयुक्त अरब अमीरात"}
                                </option>
                          : 
                                <option
                                  value={"ARE"}
                                
                                >
                                  {"United Arab Emirates"}
                                </option>
                              
                            }
                    </>
                  }
                    </select>
            <div style={{height:'0.5rem'}}>
             <ErrorMessage
               name="country"
               component="div"
               className="error-message"
             />
             </div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_accountno"]?.label !== undefined
            ? General?.codeLabels["cm_accountno"]?.label
            : "Bank Account Number"}*
          <Field
            disabled={edit ? false : true}
            type="number"
            name="accNumber"
            placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
            // defaultValue={
            //   bankData.bankAccountNumber ? bankData.bankAccountNumber : ""
            // }
            style={{ background: !edit ? "#fff" : "#edf4f6" }}
            innerRef={bankAccountNumberRef}
            readOnly
          />
            <div style={{height:'0.5rem'}}>
            <ErrorMessage
              name="accNumber"
              component="div"
              className="error-message"
            />
            </div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_iban_umber"]?.label?General?.codeLabels["cm_iban_umber"]?.label:'IBAN Number'}*
          <Field
            disabled={edit ? false : true}
            type="text"
            name="iban"
            placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
            // defaultValue={bankData.ibanNumber ? bankData.ibanNumber : ""}
            style={{ background: !edit ? "#fff" : "#edf4f6" }}
            innerRef={ibanNumberRef}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const iban = e.target.value;
                      setFieldValue("iban", iban);
                      const digits = iban.replace(/\D/g, "");
                      const last16 = digits.slice(-16);
                      if (last16.length === 16) {
                        setFieldValue("accNumber", last16);
                      }
                      else{
                        setFieldValue("accNumber", "");
                      }
                      }}
          />
           <div style={{height:'0.5rem'}}>
             <ErrorMessage
               name="iban"
               component="div"
               className="error-message"
             />
             </div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_swiftcode"]?.label !== undefined
            ? General?.codeLabels["cm_swiftcode"]?.label
            : "Swift Code"}*
          <Field
            disabled={edit ? false : true}
            type="text"
            name="swift"
            placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
            style={{ background: !edit ? "#fff" : "#edf4f6" }}
            innerRef={swiftCodeRef}
          />
           <div style={{height:'0.5rem'}}>
             <ErrorMessage
               name="swift"
               component="div"
               className="error-message"
             />
             </div>
        </Label>
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
            {General?.codeLabels["cm_bankname"]?.label !== undefined
            ? General?.codeLabels["cm_bankname"]?.label
            : "Bank Name"}*
                <Autocomplete
                  freeSolo
              disabled={edit ? false : true}
              style={{ width: "100%" ,backgroundColor: !edit ? "#fff" : "#edf4f6" }}
              options={bankNames}
              getOptionLabel={(option) => typeof option === 'string' ? option : option.bankName}
                  // defaultValue={bankNames.find(bank => bank.bankName === bankData.bankName) || null}
                  defaultValue={bankData.bankName}

              onChange={async(_, value) => {
                if (value) {
                  const bankName = typeof value === 'string' ? value : value.bankName;
                  const swiftCode = typeof value === 'string' ? '' : (value.swiftCode || '');
                  setOpenBankNameInput(value.bankName === 'Other');
                  await Promise.all([
                    setFieldValue("bankName", bankName),
                    setFieldValue("swift", swiftCode)])
                    await validateForm();

                }
                if (value && value.bankName === 'Other') { 
                  setFieldValue("otherBankName", "");
                }
                if (!value || value === "") {
                  setFieldValue("bankName", "");
                  setOpenBankNameInput(false);
                  setFieldValue("swift", "");
                  await validateForm();

                }
              }}
              sx={{
                display: 'inline-block', 
                width: '100%',
                height: '55px',
                '& .MuiOutlinedInput-root': {
                  height: '55px',
                  padding: '0 8px',
                  backgroundColor: !edit ? "#fff" : "#edf4f6"
                 
                },
                '&.MuiInputBase-root': {
                  height: '55px',
                  backgroundColor: !edit ? "#fff" : "#edf4f6"
                },
                '& input': {
                    height: '20px',
                    padding: '2px 8px',
                    border: 'none !important',
                    background: !edit ? "#fff !important" : "#edf4f6 !important",
                    // color: !edit ? "#fff" : "#edf4f6"
                },
                '&.MuiButtonBase-root': {
                  backgroundColor: !edit ? "#fff" : "#edf4f6",
      
        }
              }}
              renderInput={(params) => (
                <TextField 
                  {...params}
                  name="bankName"
                  value={bankData.bankName}
                  placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
                  style={{ background: !edit ? "#fff" : "#edf4f6" }}
                  inputRef={bankNameRef}
                />
              )}
            />
          <div style={{height:'0.5rem'}}>
             <ErrorMessage
               name="bankName"
               component="div"
               className="error-message"
             />
            </div>
              
              </Label>
              {openBankNameInput && (
              <Label
                className={General?.textClass}
                  style={{
                    fontWeight: "700",
                    fontStyle: "normal",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    lineHeight: "16px",
                    gap: "0.5rem",
                  }}
        >
                    {General?.codeLabels["cm_bankname"]?.label !== undefined
                      ? General?.codeLabels["cm_bankname"]?.label
                      : "Bank Name"}*
                <Field
                   type="text"
                    name="otherBankName"
                    // defaultValue={bankData.bankName}
                  placeholder={General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here'}
                  style={{ background: !edit ? "#fff" : "#edf4f6",zIndex:100 }}
                  innerRef={otherBankNameRef}
                  />
                <div style={{height:'0.5rem'}}>
                <ErrorMessage
                  name="bankName"
                  component="div"
                  className="error-message"
                />
                  </div>
              </Label>
                 )}
        <Label
        className={General?.textClass}
          style={{
            fontWeight: "700",
            fontStyle: "normal",
            fontSize: `${General.accessibility.fontSize}rem`,
            lineHeight: "16px",
            gap: "0.5rem",
          }}
        >
          {General?.codeLabels["cm_bankbranchname"]?.label !== undefined
            ? General?.codeLabels["cm_bankbranchname"]?.label
            : "Branch"}*
          <Field
            disabled={edit ? false : true}
            type="text"
            name="branchName"
            placeholder={edit ? General?.codeLabels["cm_type_here"]?.label?General?.codeLabels["cm_type_here"]?.label:'Type Here': ""}
            style={{ background: !edit ? "#fff" : "#edf4f6" }}
            innerRef={bankBranchNameRef}
          />
          <div style={{height:'0.5rem'}}>
             <ErrorMessage
               name="branchName"
               component="div"
               className="error-message"
             />
             </div>
        </Label>
        <hr
          style={{
            width: "100%",
            gridColumn: "1 / span 2",
            backgroundColor: "#101E8E",
            mixBlendMode: "normal",
            opacity: "0.2",
          }}
        />
        {/* <button type="submit" disabled={isSubmitting}>
            Submit
          </button> */}
        <div style={{ gridColumn:General?.isLargeScreen?"1 / span 2":"", display: "flex", flexDirection:General?.isLargeScreen?"row":"column", gap: "30px" }}>
          <ButtonSecondary
            style={{
              height: "50px",
              padding: "auto",
              fontSize: `${General.accessibility.fontSize}rem`,
            }}
            onClick={Previous}
            className={General?.colorClass}
          >
            {General?.codeLabels["cm_backbutton"]?.label !== undefined
              ? General?.codeLabels["cm_backbutton"]?.label
              : "BACK"}
          </ButtonSecondary>
          <ButtonSecondary
            style={{
              height: "50px",
              color: "#fff",
              background: "#101e8e",
              fontSize: `${General.accessibility.fontSize}rem`,
            }}
            type="submit" disabled={isSubmitting}
            className={General?.colorClass}
          >
            {loader||refundLoader?<Spinner width="30px" height="30px" />: General?.codeLabels['cm_btncontinue']?.label}
          </ButtonSecondary>
        </div>
        </TabContainer>
          </form>
      )}
        </Formik>
    </>
  );
};

export default observer(RefundDetails);
